<template>
  <div>
    <HmwControl @subcommand="subcommand"></HmwControl>
    <TimerControl @subcommand="subcommand"></TimerControl>
    <TeamStatusControl :subject="slide.settings.subject" type="answers"></TeamStatusControl>
  </div>

</template>

<script>
import HmwControl from '../controls/HmwControl';
import TeamStatusControl from "../controls/TeamStatusControl";

import BaseSlide from './BaseSlide';
import TimerControl from "../controls/TimerControl";
export default {
	name: 'HmwSlide',
	mixins: [BaseSlide],
	components: {
		HmwControl,
    TeamStatusControl,
    TimerControl,
	},
};
</script>

<style scoped></style>
